import React, { Component } from 'react';
import Field from './Field';
import PasswordStrength from './PasswordStrength';
import LoadingSpinner from '../common/LoadingSpinner.js';
import TFAVerification from './TFAVerification.js';
import TreeSelect from './TreeSelect.js';
import Checklist from './Checklist.js';
import Authenticate from './Authenticate.js';
import Textarea from './Textarea.js';
import ToggleSwitch from './ToggleSwitch.js';

class Form extends Component {
  render() {
    if (this.props.isLoading) {
      return (
        <LoadingSpinner />
      )
    } else {
      return (
        <form onSubmit={this.props.onSubmit}>
            <h2 className="form-title">{this.props.title}</h2>

            {this.props.children}

        </form>
      )
    }
  }
}

export {
  Form,
  Field,
  PasswordStrength,
  TFAVerification,
  TreeSelect,
  Checklist,
  Authenticate,
  Textarea,
  ToggleSwitch,
}



// WEBPACK FOOTER //
// ./src/Components/Form/Form.js